import gql from 'graphql-tag';

export const GET_QUIZZ = gql`
  query GetQuestions($query: QuestionQuery!) {
    getQuestions(query: $query) {
      data {
        _id
        type
        name
        description
        responses {
          isRight
          response
        }
        lesson {
          _id
          name
        }
      }
    }
  }
`;
